import usdIconPng from '/img/icons/usd-v2.png';
import usdIconWebp from '/img/icons/usd-v2.webp';
import usdLargePng from '/img/icons/usd-v2-large.png';
import usdLargeWebp from '/img/icons/usd-v2-large.webp';

export const usdImages = {
  icon: {
    png: usdIconPng,
    webp: usdIconWebp,
  },
  iconLarge: {
    png: usdLargePng,
    webp: usdLargeWebp,
  },
};
